import React, { useEffect, useState } from "react";
import CommonToaster from "./CommonToaster";

/**
 * Global toast for an action the server refused for want of a permission
 * (403 PERMISSION_REQUIRED, raised by utils/apiClient as `vc-permission-denied`).
 * It names the permission, so the person knows what to ask for — the page's
 * own error usually only says "failed".
 *
 * Rendered once in App.js, beside PlanLimitToast.
 */
const PermissionDeniedToast = () => {
  const [labels, setLabels] = useState(null);

  useEffect(() => {
    const onDenied = (e) => setLabels(e.detail?.labels || []);
    window.addEventListener("vc-permission-denied", onDenied);
    return () => window.removeEventListener("vc-permission-denied", onDenied);
  }, []);

  if (!labels) return null;
  const names = labels.length ? labels.map((l) => `“${l}”`).join(" or ") : "a permission you do not have";
  return (
    <CommonToaster
      show
      type="warning"
      position="top-center"
      delay={6000}
      message={`You can't do this — it needs ${names}. Ask your super admin if you should have it.`}
      onClose={() => setLabels(null)}
    />
  );
};

export default PermissionDeniedToast;
